// Default search values for filtering carts
export const searchValues = {
  user: "",
  action: "",
  toDate: "",
  fromDate: "",
  activity: "",
};

// actions list options
export const actionOptions = [
  { value: 0, color: "green", name: "المشاريع" },
  { value: 1, color: "yellow", name: "الاهداءات" },
  { value: 2, color: "default", name: "الطلبات" },
  { value: 3, color: "dark", name: "المستخدمين" },
];

// activity list options
export const activityOptions = [
  { value: 0, color: "green", name: "إضافة" },
  { value: 1, color: "yellow", name: "تعديل" },
  { value: 2, color: "red", name: "حذف" },
  { value: 3, color: "dark", name: "تصدير" },
];
